<template>
  <div>
    <Table
      resource="AdministratorV2"
      :detail-route="row => `/v2/administrators/${row.id}/detail`"
      :actions="actions"
      :items="$store.getters['administratorV2/tableData']"
      :detail="$store.getters['administratorV2/detailData']"
      :fields="$store.getters['administratorV2/tableFields']"
      :pagination="$store.state.administratorV2.tablePagination"
      :keyword="$store.state.administratorV2.tableKeyword"
      :loading="$store.state.administratorV2.loadingTable"
      :filter="$store.state.administratorV2.tableFilter"
      :sort="$store.state.administratorV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />

    <!-- Reset Password confirmation modal -->
    <b-modal
      v-model="resetPasswordModalVisible"
      title="Atur Ulang Sandi?"
      ok-title="Ya, kirim email"
      ok-variant="primary"
      cancel-title="Batal"
      cancel-variant="white"
      @ok="handleOkResetPassword"
    >
      <p v-if="selectedAdministrator">
        Anda akan mengirim email reset password ke {{ selectedAdministrator.name || 'pengguna' }} ({{ selectedAdministrator.email }}). Lanjutkan?
      </p>
    </b-modal>
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'
import { BModal } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    Table,
    BModal,
  },
  data() {
    return {
      resetPasswordModalVisible: false,
      selectedAdministrator: null,

      // Sort
      sortOptions: [
        {
          key: 'last_login_at', direction: 'desc', label: 'Terakhir Login', default: true,
        },
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru',
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
        {
          type: 'other',
          children: [
            {
              label: 'Paksa Logout',
              event: data => this.confirmForceLogout(data.item),
              visibility: {
                callback: data => Boolean(data && data.item && data.item.id),
              },
            },
            {
              label: 'Atur Ulang Sandi',
              event: data => this.confirmResetPassword(data.item),
              visibility: {
                callback: data => Boolean(data && data.item && data.item.id),
              },
            },
          ],
        },
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('administratorV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('administratorV2/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('administratorV2/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('administratorV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('administratorV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('administratorV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('administratorV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('administratorV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('administratorV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('administratorV2/SET_TABLE_KEYWORD', val)
    },
    confirmResetPassword(item) {
      this.selectedAdministrator = item
      this.resetPasswordModalVisible = true
    },
    handleOkResetPassword() {
      this.$store.dispatch('administratorV2/forgotPassword', { email: this.selectedAdministrator.email })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Berhasil',
              icon: 'CheckIcon',
              text: `Email reset password telah dikirim ke ${this.selectedAdministrator.email}.`,
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Gagal',
              icon: 'XIcon',
              text: error?.response?.data?.message || 'Gagal mengirim email reset password.',
              variant: 'danger',
            },
          })
        })
    },
    async confirmForceLogout(administrator) {
      if (!administrator || !administrator.id) {
        return
      }

      const result = await this.$swal({
        title: 'Paksa logout pengguna?',
        text: `Tindakan ini akan mengakhiri sesi aktif ${administrator.name || 'pengguna'}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, paksa logout',
        cancelButtonText: 'Batal',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ml-1',
        },
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !this.$swal.isLoading(),
        preConfirm: () => this.$store.dispatch('administratorV2/forceLogout', administrator.id)
          .catch(error => {
            this.$swal.showValidationMessage(error?.response?.data?.message || 'Gagal memaksa logout pengguna')
            throw error
          }),
      })

      if (result.isConfirmed) {
        this.$swal({
          title: 'Berhasil',
          text: `${administrator.name || 'Pengguna'} telah dipaksa logout.`,
          icon: 'success',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      }
    },
  },
}
</script>
